import { Outlet } from "react-router-dom";
import AppNavbar from "../AppNavbar";

const AdminLayout = () => {
  return (
    <AppNavbar>
      <Outlet />
    </AppNavbar>
  );
};

export default AdminLayout;
